import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: '[appAlphabetOnly]' })
export class AlphabetOnlyDirective {
  private readonly navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste'
  ];
  inputElement: HTMLElement;

  constructor(public el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (
      this.navigationKeys.indexOf(e.key) > -1 ||
      ((e.key === 'a' || e.key === 'c' || e.key === 'v' || e.key === 'x' || e.key === 'a') && e.ctrlKey === true) ||
      ((e.key === 'a' || e.key === 'c' || e.key === 'v' || e.key === 'x' || e.key === 'a') && e.metaKey === true)
    ) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    // if (e.keyCode < 65 || e.keyCode > 91) {
    if ((e.key < 'a' || e.key > 'z') && (e.key < 'A' || e.key > 'Z')) {
      e.preventDefault();
    } else if (!/[a-z]/gi.test(e.key)) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedInput: string = event.clipboardData.getData('text/plain').replace(/[^a-z]/gi, '');
    document.execCommand('insertText', false, pastedInput);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    const textData = event.dataTransfer.getData('text').replace(/[^a-z]/gi, '');
    this.inputElement.focus();
    document.execCommand('insertText', false, textData);
  }
}
